module.exports = __webpack_public_path__ + "img/jinshanyun.05aa64d5.png";